
import { Options, Vue } from 'vue-class-component';
import { EstimationClient, FootwearEstimationClient } from '@/services/Services';
import { ExportServices } from '@/services/ExportServices';
import { baseUrl } from '@/config';
import SummaryCharts from '@/views/calculator/components/summaryCharts.vue';
import store from '@/store';
import * as OM from '@/Model';

@Options({
    components: {
        SummaryCharts
    }
})
export default class Summary extends Vue {
    
    estimationIdentifier: string = "";
    model: OM.SummaryVM = new OM.SummaryVM;
    loaded: boolean = false;

    created() {
        this.estimationIdentifier = this.$route.params.estimationIdentifier.toString();
        this.init();
    }
    
    init() {
        FootwearEstimationClient.summary(this.estimationIdentifier)
        .then(x => {
            this.model = x;
            this.loaded = true;

            store.state.estimationIdentifier = this.estimationIdentifier;
        })
    }

    downloadPDF() {
        FootwearEstimationClient.getPDFName(this.estimationIdentifier)
        .then(x => {
            this.$utils.downloadPdf(baseUrl + "api/FootwearEstimation/DownloadPDF", this.estimationIdentifier, x);
        })
    }

    exportCsv() {
        FootwearEstimationClient.exportCsv(this.estimationIdentifier)
        .then(x => {
            ExportServices.DownloadExport(x.identifier, x.text);
        })
    }

}
